import { CheckCircle2 } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function MeetMarc() {
  return (
    <section
      data-testid="meet-marc-section"
      id="meet-marc"
      className="relative bg-[#0E1213] py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-16 overflow-hidden border-t border-[#27272A]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative">
            <div className="zoom-wrap aspect-[3/4] border border-[#27272A] overflow-hidden bg-[#080A0B]">
              <img
                src="/assets/marc.jpg"
                alt="Marc — Founder and Director of MarX Plumbing"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="hidden md:block absolute -top-8 -left-8 w-40 h-40 bg-[#3FB8DC] z-[-1]" />
            <div className="hidden md:flex absolute -bottom-6 -right-6 bg-[#080A0B] border border-[#27272A] p-6 flex-col gap-1">
              <span className="eyebrow" style={{ fontSize: "0.6rem" }}>Founder & Director</span>
              <span className="font-serif-display text-2xl text-[#F4F0EB]">Marc</span>
              <span className="text-[#A1A1AA] text-xs">10+ years on the tools</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={180} className="lg:col-span-7">
          <div className="flex items-center gap-4 mb-8">
            <span className="block w-10 h-px bg-[#3FB8DC]" />
            <span className="eyebrow">Meet Marc</span>
          </div>

          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#F4F0EB] leading-[1.02] tracking-tight">
            The <span className="italic text-[#A1A1AA]">hands behind </span>
            <span className="text-[#3FB8DC]">every job.</span>
          </h2>

          <p className="mt-8 text-white text-base md:text-lg leading-relaxed">
            Marc is the founder and Director of MarX Plumbing Services, bringing
            over 10+ years of experience across residential, commercial and
            high-end plumbing projects throughout Sydney.
          </p>

          <p className="mt-5 text-[#A1A1AA] text-base md:text-lg leading-relaxed">
            With a strong focus on renovations, custom homes and quality plumbing
            installations, Marc built MarX Plumbing around a simple approach —
            do things properly, communicate clearly and take pride in every
            detail. From the initial consultation and planning through to
            rough-in, installation and final fit-off, Marc remains closely
            involved throughout each project.
          </p>

          <p className="mt-5 text-[#A1A1AA] text-base md:text-lg leading-relaxed">
            His attention to detail and high standard of workmanship ensure every
            job is completed with consideration for both the plumbing behind the
            walls and the finished space you see.
          </p>

          <p className="mt-5 text-[#A1A1AA] text-base md:text-lg leading-relaxed">
            For Marc, MarX Plumbing is about more than completing the job. It's
            about building long-term relationships with clients, builders and
            designers through reliable service, honest communication and
            workmanship that speaks for itself.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-6 border-t border-[#27272A] pt-8 max-w-xl">
            <div>
              <div className="font-serif-display text-3xl md:text-4xl text-[#F4F0EB]">10+</div>
              <div className="eyebrow mt-2" style={{ fontSize: "0.55rem" }}>Years on the tools</div>
            </div>
            <div>
              <div className="font-serif-display text-3xl md:text-4xl text-[#F4F0EB]">472396C</div>
              <div className="eyebrow mt-2" style={{ fontSize: "0.55rem" }}>NSW Licensed</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
